import { render, staticRenderFns } from "./modellingRight.vue?vue&type=template&id=ab69aa68&scoped=true"
import script from "./modellingRight.vue?vue&type=script&lang=js"
export * from "./modellingRight.vue?vue&type=script&lang=js"
import style0 from "./modellingRight.vue?vue&type=style&index=0&id=ab69aa68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab69aa68",
  null
  
)

export default component.exports